import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MO_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MO_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#1C9975"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MO_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#MO_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.02 6.853l-1.634.987.373-1.925-1.36-1.44 1.842-.078.779-1.797.78 1.797h1.838l-1.357 1.518.409 1.925-1.67-.987zM11.383 7.584l-1.01.61.23-1.19-.841-.89 1.139-.049.482-1.11.482 1.11h1.137l-.84.94.253 1.19-1.032-.61zM20.58 7.584l-1.01.61.23-1.19-.841-.89 1.139-.049.482-1.11.482 1.11h1.137l-.84.94.253 1.19-1.032-.61zM8.766 9.61l-.811.49.185-.955-.675-.715.914-.038.387-.892.386.892h.913l-.674.753.203.955-.828-.49zM23.56 9.61l-.81.49.185-.955-.675-.715.914-.038.387-.892.386.892h.913l-.674.753.203.955-.828-.49z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MO_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 8,
      y: 6,
      width: 16,
      height: 16
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 22a8 8 0 100-16 8 8 0 000 16z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#MO_svg__c)", fill: "#F7FCFF" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.682 21.064h6.638v1.072h-6.638v-1.072zM9.957 19.46h12.766v.983H9.957v-.983z"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M12.62 19.02H8.715v-1h3.898c1.38-.02 2.39-.413 3.062-1.172l.336-.378.374.34c.9.814 1.797 1.21 2.706 1.21h4.304v1h-4.304c-1.044 0-2.052-.392-3.015-1.161-.853.756-2.012 1.14-3.456 1.161z" })), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.035 7.607s-1.709 1.688-1.709 4.005c0 .493.077.959.2 1.387-.548-1.218-.585-2.54-.111-3.98l-.647-.212c-.483 1.468-.485 2.848-.005 4.127a8.213 8.213 0 00-3.307-1.13l-.075.677a7.522 7.522 0 012.907.963 5.395 5.395 0 00-.687-.226c-2.163-.552-4.285.231-4.285.231s1.224 2.746 3.595 3.152c.118.02.233.035.348.047h-.016c-1.13 0-2.181-.462-3.166-1.401l-.47.492c1.106 1.055 2.322 1.59 3.636 1.59 1.285 0 2.478-.511 3.568-1.519a3.73 3.73 0 00.296-.195l.043.037-.034.06s.108.064.301.156c1.077.835 2.425 1.461 3.491 1.461 1.314 0 2.53-.535 3.636-1.59l-.47-.492c-.984.94-2.036 1.401-3.166 1.401-.413 0-.818-.066-1.215-.2.556.03 1.169-.02 1.803-.214 2.335-.714 3.309-2.873 3.309-2.873s-1.244-.671-2.823-.678a7.912 7.912 0 011.11-.202l-.075-.676c-1.48.163-2.762.663-3.836 1.497.628-1.38.677-2.885.147-4.495l-.647.213c.433 1.316.44 2.533.02 3.662.072-.334.114-.692.114-1.07 0-2.442-1.78-4.005-1.78-4.005zm.752 7.148l-.03.044.036-.045h-.006zm-1.652-.16l.067-.06c.06.1.121.195.18.284a7.878 7.878 0 00-.247-.223z",
      fill: "#F7FCFF"
    }
  )))
), a = t;
export {
  a as default
};
